import { useEffect } from "react";
import { useLocation } from "react-router";
import { BlockTitle } from "@blocks/Blocks";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import useDropdown from "@hooks/useDropdown";
import useTabs, { TabType } from "@hooks/useTabs";
import { AWARDS_TAB } from "@sca/utils/constants";
import { SCAAwardsTabFactory } from "@sca/utils/helpers";

import AwardsTab from "./AwardsTab";

/**
 * Component to render SCA award page
 */
const SCASingleAwardPage = (): React.ReactElement => {
  const { pathname } = useLocation();
  const segments = pathname.split("/");
  const page = segments[segments.length - 1];

  const { isOpen, toggleDropdown, closeDropdown } = useDropdown();
  const { activeTab, activeLabel, changeTab } = useTabs(AWARDS_TAB);

  const isTabType = (pageUrl: string): pageUrl is TabType =>
    AWARDS_TAB.some((tab) => tab.key === pageUrl);

  useEffect(() => {
    if (!isTabType(page)) return;

    changeTab(page);
  }, [page, changeTab]);

  const SCAAwardsTab = SCAAwardsTabFactory(activeTab);

  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="sca-single-awards-page-component"
    >
      <div className="relative w-full font-public-sans">
        <div onClick={toggleDropdown} className="jystify-center flex flex-row">
          <BlockTitle
            text={activeLabel}
            rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6 hover:underline cursor-pointer"
          />

          <IconFactory type={IconTypeEnum.arrowDown} x={30} y={28} size={50} />
        </div>

        {isOpen ? (
          <AwardsTab
            activeLabel={activeLabel}
            changeTab={changeTab}
            closeDropdown={closeDropdown}
          />
        ) : null}
      </div>

      {SCAAwardsTab ? <SCAAwardsTab /> : null}
    </div>
  );
};

export default SCASingleAwardPage;
